<template>
  <div class="finish-question">
    <div class="header">
      <div class="icon-quizz">
        <span>QUIZZ</span>
      </div>
      <div class="tags-quiz">
        <p
          class="tag"
          v-for="(tag, index) in quiz.scriptOptions.tags"
          :key="index"
        >
          {{ tag.name }}
        </p>
      </div>
      <div class="re-quiz" v-on:click="reQuiz">
        <ReloadIcon />
        <span>Làm lại quiz</span>
      </div>
      <p class="name-quiz">{{ quiz.name }}</p>
    </div>

    <div class="result">
      <div class="content">
        <p class="outcome">{{ info.title }}</p>
        <p class="description">{{ info.text }}</p>
      </div>
      <div class="image" v-if="info.media != null">
        <img :src="info.media.value.src" />
      </div>
      <div class="footer">
        <p class="text-share">Chia sẻ ngay với bạn bè!</p>
        <div class="group-btn">
          <div class="share-fb" @click="shareFb(info)">
            <FacebookIcon />
            <span>Chia sẻ</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReloadIcon from "../../ui/icons/svgs/icons/ReloadIcon";
import FacebookIcon from "../../ui/icons/svgs/icons/FacebookIcon";
import ConnectIcon from "../../ui/icons/svgs/icons/ConnectIcon";
import { copyClipboard, addParameter } from "coreutils-js";

export default {
  name: "Result",
  props: ["quiz", "total_poin"],
  components: {
    ReloadIcon,
    FacebookIcon,
    ConnectIcon,
  },
  data() {
    return {
      sharing: false,
      resultId: null,
    };
  },
  computed: {
    info: function () {
      let infoResult = {};
      const poin = this.total_poin;
      this.quiz.results.filter(function (result) {
        if (result.from <= poin && poin <= result.to) {
          infoResult = result;
        }
      });
      return infoResult;
    },
    // bgImageResult: function(){
    //   if (this.info.media != null){
    //     return this.info.media.value.src.includes('gif') ? this.info.media.value.src + '.png' : this.info.media.value.src
    //   }
    //   return ''
    // }
  },
  methods: {
    reQuiz() {
      this.$store.dispatch("reQuiz");
    },
    shareFb(data) {
      //   this.quiz.action(
      //     "share",
      //     "facebook",
      //     `${data.title} - ${data.text}`,
      //     `${this.quiz.scriptOptions.linkShare || document.referrer}`
      //   );
      this.quiz.action("share", "facebook", {
        title: data.title,
        image: ((data.media || {}).value || {}).src,
        description: data.text,
        quote: `${data.title || ""} - ${data.text || ""}`,
        url: this.quiz.scriptOptions.linkShare,
      });
    },
    // coppyLink() {
    //   copyClipboard(this.quiz.scriptOptions.linkShare);
    // }
  },
};
</script>

<style lang="scss">
.finish-question {
  // ::before {
  //   display: block;
  //   width: 100%;
  //   height: 101%;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   content: "";
  //   z-index: -1;
  //   backdrop-filter: blur(100px);
  // }
  border-radius: 8px;
  //   margin: 80px 0 40px;
  margin: 80px 0 0 0;
  padding: 16px;
  background-size: cover;
  background-position: center center;
  position: relative;
  z-index: 0;
  overflow: hidden;
  background-image: linear-gradient(#ff5e34, #ff9b34);
  .header {
    padding: 0 16px;
    display: flex;
    align-items: center;
    position: relative;
    flex-wrap: wrap;
    margin-bottom: 16px;
    .icon-quizz {
      height: 40px;
      width: 40px;
      background: #ffe700;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: #000000;
        transform: matrix(1, -0.24, 0, 0.97, 0, 0);
        font-size: 10px;
        font-weight: 1000;
      }
    }
    .tags-quiz {
      display: flex;
      .tag {
        background: rgba(0, 0, 0, 0.1);
        margin-left: 8px;
        height: 14px;
        padding: 5px 12px;
        border-radius: 18px;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
        color: #fff;
      }
    }
    .re-quiz {
      cursor: pointer;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -53px;
      top: unset;
      @media screen and (min-width: 500px) {
        right: 16px;
        top: 8px;
        left: unset;
        bottom: unset;
      }
      background: rgba(0, 0, 0, 0.1);
      height: 14px;
      padding: 5px 12px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        width: 12px;
        fill: #fff;
      }
      span {
        font-weight: 600;
        font-size: 12px;
        line-height: 2;
        color: #ffffff;
        margin-left: 6px;
        margin-top: 2px;
      }
    }
    .name-quiz {
      width: 100%;
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      color: #ffffff;
      margin-top: 8px;
      padding-bottom: 32px;
      @media screen and (min-width: 500px) {
        padding-bottom: 0;
      }
    }
  }

  .result {
    margin: 0 16px;
    padding: 24px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .content {
      width: 100%;
      margin-bottom: 20px;
      @media screen and (min-width: 500px) {
        width: calc(100% - 240px);
      }

      .outcome {
        font-weight: bold;
        font-size: 26px;
        line-height: 30px;
        color: #333333;
        margin-bottom: 16px;
      }
      .description {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #666666;
        white-space: break-spaces;
      }
    }
    .image {
      width: 100%;
      margin-bottom: 20px;
      @media screen and (min-width: 500px) {
        width: 200px;
      }
      img {
        width: 100%;
        border-radius: 8px;
      }
    }
    .footer {
      width: 100%;
      .compare {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #999999;
        span {
          color: #ff6d19;
        }
      }
      .text-share {
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #666666;
        margin-bottom: 10px;
      }

      .group-btn {
        width: 230px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .share-fb {
          cursor: pointer;
          background: #3479ea;
          border-radius: 3px;
          width: 82px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 13px;
          line-height: 140%;
          svg {
            width: 12px;
            margin-right: 4px;
          }
        }
        .coppy-link {
          cursor: pointer;
          width: 138px;
          height: 28px;
          background: #f4f4f4;
          border-radius: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999999;
          font-size: 13px;
          line-height: 140%;
          svg {
            width: 12px;
            fill: #999999;
            margin-right: 4px;
          }
        }
      }
    }
  }
}
</style>
